export const getDateWithTime = (d: string): string => {
	const [hour, minutes] = new Date(d).toLocaleTimeString('ru-RU').split(':');
	return `${hour}:${minutes}`;
};
